import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';

export const goBack = ({ history }) => () => history.goBack();

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['backString'],
  }),
  withRouter,
  withHandlers({ goBack }),
);
